import { changePathSelectRetention as changePathSelectRetentionDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type PathSelectRetentionProps = {
    mode?: string;
}

export const changePathSelectRetention = ({
    mode,
}: PathSelectRetentionProps) => {
    changePathSelectRetentionDiagram({ mode });
};
